var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import Drawer from "antd/es/drawer";
import "antd/es/drawer/style/index.js";
import List from "antd-mobile/es/list";
import "antd-mobile/es/list/style/index.js";
import { observer } from 'mobx-react';
import { runtime } from '../../../../classes/runtime/Runtime';
let MenubarMobileRightDrawer = class MenubarMobileRightDrawer extends React.PureComponent {
    get menubarMobile() {
        return this.props.app.menubar.menubarMobile;
    }
    get premiumDialog() {
        const { app } = this.props;
        if (!app.menubarRight.isPremiumDialogShowing)
            return null;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { PremiumDialog_ } = runtime.streamedPackages.Lazy.components;
        return React.createElement(PremiumDialog_, { app: app });
    }
    render() {
        const { app } = this.props;
        return (React.createElement(Drawer, { title: "", placement: "right", visible: this.menubarMobile.isRightDrawerOpen, style: { marginTop: 45 }, bodyStyle: { padding: 0 }, onClose: this.menubarMobile.closeRightDrawer, destroyOnClose: true },
            React.createElement(List, { renderHeader: "Upgrade" },
                React.createElement(List.Item, { arrow: "horizontal", onClick: app.menubarRight.togglePremiumDialog },
                    "Schlaukopf Premium",
                    this.premiumDialog),
                React.createElement(List.Item, { arrow: "horizontal", thumb: React.createElement("i", { className: "fas fa-tablet" }), onClick: app.menubarRight.toggleAppInfoDialog }, "Mobile Version als App")),
            React.createElement(List, { renderHeader: "Informationen" },
                React.createElement("a", { href: "/info/faq" },
                    React.createElement(List.Item, { arrow: "horizontal", thumb: React.createElement("i", { className: "fas fa-users" }) }, "H\u00E4ufige Fragen")),
                React.createElement("a", { href: "/info/projekt" },
                    React.createElement(List.Item, { arrow: "horizontal", thumb: React.createElement("i", { className: "fas fa-road" }) }, "\u00DCber das Projekt")),
                React.createElement("a", { href: "/info/impressum" },
                    React.createElement(List.Item, { arrow: "horizontal", thumb: React.createElement("i", { className: "fas fa-info" }) }, "Impressum")),
                React.createElement("a", { href: "/info/datenschutz" },
                    React.createElement(List.Item, { arrow: "horizontal", thumb: React.createElement("i", { className: "fas fa-suitcase" }) }, "Datenschutz")))));
    }
};
MenubarMobileRightDrawer = __decorate([
    observer
], MenubarMobileRightDrawer);
export { MenubarMobileRightDrawer };
